module.exports = __webpack_public_path__ + "static/media/podium-star.803e16ac.svg";